<template>
<div class="fc-page mg-page mg-goods_stock_list"><nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="mg-breadcrumb"/></nav><header class="fc-heading"><div class="fc-child-heading"><h1>商品库存</h1><p>查看各类商品库存，及时调整物资数量</p></div><div class="mg-heading-actions"><v-btn  @click="showAddDialog" color="#d9363e" depressed class="mg-create">库存调整</v-btn></div></header><section class="fc-filters" aria-label="商品库存筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>按条件查找需要的记录</span></div><form @submit.prevent="getTableDataList"><div class="fc-filter-grid"><div class="fc-filter-cell"><v-text-field clearable dense label="商品名称" outlined v-model="query.goodsName" color="#d9363e" aria-label="商品名称">
							</v-text-field></div></div><div class="fc-filter-bottom"><span>设置条件后点击查询</span><v-btn type="submit" color="#d9363e" dark depressed class="mg-query"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></form></section><section class="fc-records" aria-label="库存明细"><div class="fc-list-heading"><h3>库存明细</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div><v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table mg-table"
			disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......" :mobile-breakpoint="0" no-data-text="暂无符合条件的记录">


			<template v-slot:item.masterImg="{item}">
				<v-avatar rounded class="my-1">
					<v-img v-if="item.masterImg" :src="imgPrev + item.masterImg" width="50" height="50"></v-img>
				</v-avatar>
			</template>
		<template v-slot:item.stock="{item}"><span class="fc-number">{{item.stock}}</span></template></v-data-table><div class="fc-pagination"><div class="fc-page-size"><v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
						outlined v-model="query.size" color="#d9363e" aria-label="每页数量" /><span>条 / 页</span><span class="fc-total">共 {{data.total}} 条</span></div><div v-if="Math.ceil(data.total/query.size)>0" class="mg-pagination"><v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
						:total-visible="5" v-model="query.page" color="#d9363e" /></div></div></section><v-dialog title="调整库存" v-model="add.dialog" max-width="600" scrollable>
		<v-card class="fc-dialog-card mg-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-package-variant-closed</v-icon></span><div class="mg-dialog-title"><h2><span>库存调整</span></h2><p>完善信息后保存修改</p></div><v-spacer/><v-btn icon aria-label="关闭调整库存" @click="add.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

			<v-card-text class="fc-dialog-body">
				<v-row dense>

					<v-col cols="12">
						<v-select :items="selectGoodsList" v-model="add.stock.goodsId"
						item-text="goodsName" item-value="id" label="商品" dense outlined color="#d9363e" aria-label="商品"></v-select>
					</v-col>
					<v-col cols="12" class="mt-n5">
						<v-radio-group row v-model="add.stock.inOut" label="出入库类型:">
							<v-radio label="入库" value="1"></v-radio>
							<v-radio label="出库" value="2"></v-radio>
						</v-radio-group>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field label="交接人" v-model="add.stock.bizUserName" dense outlined color="#d9363e" aria-label="交接人"></v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field label="数量" type="number" v-model="add.stock.quantity" dense outlined color="#d9363e" aria-label="数量"></v-text-field>
					</v-col>
					<v-col cols="12">
						<v-text-field label="备注" v-model="add.stock.memo" dense outlined color="#d9363e" aria-label="备注"></v-text-field>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="add.dialog=false" depressed>取消</v-btn>
				<v-btn @click="submitAddStock" color="#d9363e" depressed class="fc-confirm">确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog></div>
</template>

<script>
	import utils from "../../../config/utils"
    import global from '../../../config/global'
	export default {
		name: "goods-stock-list",
		data() {
			return {
				imgPrev: global.config.imgPre,
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: 'ERP管理中心',
						disabled: true
					},
					{
						text: '商品库存管理',
						disabled: true
					},
				],
				shopId:"",
				data: {
					total: 0,
					headers: [
						{
							text: '商品ID',
							value: 'goodsId',
							sortable: false
						},
						{
							text: '商品主图',
							value: 'masterImg',
							sortable: false
						},
						{
							text: '商品名称',
							value: 'goodsName',
							sortable: false
						},
						{
							text: '库存数量',
							value: 'stock',
							sortable: false
						},
						
					],
					list: [],
				},
				selectGoodsList:[],
				query: {
					loading: false,
					page: 1,
					size: 20,
					goodsName: "",
				},
				add: {
					dialog: false,
					stock: {
						goodsId:"",
						shopId:"",
						inOut:"",
						quantity:"",
						bizUserName:"",
						memo:""
					},
				},

			}
		},
		created() {
			// 获取门店列表
			this.shopId = utils.getCurrentShopId();
			this.getGoodsListForSelect();
			this.getTableDataList();
		},
		methods: {
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			
			showAddDialog() {
				this.add.dialog = true;
			
	
			},
			
			getTableDataList() {
				const that = this;
				this.query.loading = true;


				let url = `/erp/goods/stock/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				if (this.query.goodsName) {
					url += "&goodsName=" + this.query.goodsName;
				}
				
				this.axios.get(url).then(response => {
					
					console.log(response);
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			classStatusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "冻结";
				}
				return stName;
			},
			classStatusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			submitAddStock() {
			
				// api
				const that = this;
				let url = `/erp/goods/stock/change`;
				let postData = {...this.add.stock};
				postData.shopId = this.shopId;
			

				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});

			},
	
			getGoodsListForSelect(){
				const that = this;
				let url = `/erp/merchant/goods/list`;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectGoodsList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
		}
	}
</script>
<style>
</style>
<style lang="scss" scoped src="../../../assets/styles/management.scss"></style>
